<div class="container-box">
  <div class="header-section">
    <h1 class="page-title">Riepilogo Importazioni</h1>
    <button
      mat-raised-button
      color="primary"
      (click)="triggerManualImport()"
      [disabled]="isTriggeringImport || isLoading"
      class="trigger-button"
    >
      <mat-spinner *ngIf="isTriggeringImport" diameter="20" class="button-spinner"></mat-spinner>
      <span *ngIf="!isTriggeringImport">
        <i class="fas fa-play"></i>
        Avvia Import Manuale
      </span>
      <span *ngIf="isTriggeringImport">Avvio in corso...</span>
    </button>
  </div>

  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner></mat-spinner>
    <p>Caricamento dati...</p>
  </div>

  <div *ngIf="!isLoading && summary" class="summary-content">
    <!-- Statistiche principali -->
    <div class="stats-cards">
      <mat-card class="stat-card">
        <mat-card-content>
          <div class="stat-value">{{ summary.totalImports }}</div>
          <div class="stat-label">Totale Importazioni</div>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card completed">
        <mat-card-content>
          <div class="stat-value">{{ summary.completed }}</div>
          <div class="stat-label">Completate</div>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card in-progress">
        <mat-card-content>
          <div class="stat-value">{{ summary.inProgress }}</div>
          <div class="stat-label">In Lavorazione</div>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card failed">
        <mat-card-content>
          <div class="stat-value">{{ summary.failed }}</div>
          <div class="stat-label">Fallite</div>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card pending">
        <mat-card-content>
          <div class="stat-value">{{ summary.pending }}</div>
          <div class="stat-label">In Attesa</div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Grafico Status Importazioni -->
    <div class="charts-section">
      <mat-card class="chart-card">
        <mat-card-header>
          <mat-card-title>Status Importazioni</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="bar-chart">
            <div *ngFor="let item of statusChartData" class="bar-item">
              <div class="bar-label">{{ item.label }}</div>
              <div class="bar-container">
                <div
                  class="bar"
                  [style.width.%]="getBarHeight(item.value)"
                  [style.background-color]="item.color"
                >
                  <span class="bar-value">{{ item.value }}</span>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Tabella Registro Importazioni -->
    <div class="table-section">
      <app-table-header
        tableTitle="Registro Importazioni"
        (btnUpdateClick)="reloadTrigger$.next()"
      ></app-table-header>
      <div class="table-container">
        <app-new-table
          [dataSource]="dataSource"
          [reloadTrigger$]="reloadTrigger$"
          [displayedColumns]="displayedColumns"
          [initialSort]="{
            active: 'id',
            direction: 'desc'
          }"
        ></app-new-table>
      </div>
    </div>

    <!-- Informazioni aggiuntive -->
    <mat-card class="info-card" *ngIf="summary.lastImportDate">
      <mat-card-content>
        <div class="info-item">
          <i class="fas fa-clock"></i>
          <span>
            Ultima Importazione:
            {{
              summary.lastImportDate ? (summary.lastImportDate | date: 'dd/MM/yyyy HH:mm') : 'N/A'
            }}
          </span>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div *ngIf="!isLoading && !summary" class="no-data">
    <p>Nessun dato disponibile</p>
  </div>

  <div *ngIf="!isLoading && summary && summary.totalImports === 0" class="no-data">
    <p>Nessuna importazione trovata nel registro</p>
  </div>
</div>
